import axios from '@axios'
import { get } from '@vueuse/core'

const route = 'sales'

export default {
  namespaced: true,
  state: {
    sale: null,
    refundItems: [],
    typeRefund: 'items',
    refundValue: 0,
    refundMethod: null,
    refundObs: '',
    returnItemStock: 'yes',
    note: '',
  },
  getters: {
    getRefundItems(state) {
      return state.refundItems
    },
    getRefundValue(state) {
      return state.refundValue
    },
    getTypeRefund(state) {
      return state.typeRefund
    },
    getRefundMethod(state) {
      return state.refundMethod
    },
    getRefundObs(state) {
      return state.refundObs
    },
    getReturnItemStock(state) {
      return state.returnItemStock
    },
  },
  mutations: {
    setRefundItems(state, items) {
      state.refundItems = items
    },
    setRefundValue(state, value) {
      state.refundValue = value
    },
    setTypeRefund(state, type) {
      state.typeRefund = type
    },
    setRefundMethod(state, method) {
      state.refundMethod = method
    },

    setRefundObs(state, obs) {
      state.refundObs = obs
    },

    setReturnItemStock(state, returnItemStock) {
      state.returnItemStock = returnItemStock
    },

    setSale(state, sale) {
      state.sale = sale
    },
    setNote(state, note) {
      state.note = note
    },
  },
  actions: {
    refund(context) {
      return axios.post(`${route}/refund`, {
        sale: context.state.sale,
        refund_items: context.state.refundItems,
        refund_value: context.state.refundValue,
        type_refund: context.state.typeRefund,
        refund_value: context.state.refundValue,
        refund_method: context.state.refundMethod,
        refund_obs: context.state.refundObs,
        return_item_stock: context.state.returnItemStock,
      })
    },

    /**
     * salva a nota de venda
     */
    saveNote(context) {
      return axios.post(`${route}/save_note`, {
        sale_id: context.state.sale.id,
        note: context.state.note,
      })
    },

    /**
     * Anular venda
     */
    cancelSale(context) {
      return axios.post(`${route}/cancel`, {
        sale_id: context.state.sale.id,
      })
    },
    /**
     * Exportar nota de venda em PDF
     */
    exportNotePdf(context, saleId) {
      return axios.get(`${route}/export_note_pdf/${saleId}`, { responseType: 'blob' })
    },

    /**
     * Enviar nota de venda por email
     */
    sendEmailNote(context, { saleId, email }) {
      return axios.post(`${route}/send_email_note/${saleId}`, { email })
    },
  },
}
